const getAppBridge = () => (typeof window !== 'undefined' ? window.AppBridge : null);

export const keepScreenAwakeForPlayback = () => {
  const bridge = getAppBridge();
  try {
    // Never fall back to the microphone bridge here. It requests transient
    // audio focus and can make embedded YouTube alternate play/pause states.
    if (typeof bridge?.mediaPlaybackStart === 'function') bridge.mediaPlaybackStart();
  } catch {}
};

export const releaseScreenAwakeForPlayback = () => {
  const bridge = getAppBridge();
  try {
    if (typeof bridge?.mediaPlaybackStop === 'function') bridge.mediaPlaybackStop();
  } catch {}
};
